import React, { useEffect, useMemo, useState } from 'react';
import { Calendar, dayjsLocalizer } from 'react-big-calendar';
import CustomToolbar from './CustomToolbar';
import { DisabledWithSpinner } from '../../../../common/';
import { useGetCalendarEventMonthQuery } from '../../../../../redux/services/events.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import EventsDetailModal from './EventsDetailModal';
import {
  clearDayFromDate,
  DATETIME_FORMAT_DATE,
  isSameDate,
} from '../../../../../utils/helpers/CommonHelper';
import { useTranslation } from 'react-i18next';
import ControlsActions from '../../../../common/controls/ControlsActions/ControlsActions';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

// This component uses react-big-calendar use google for documentation
const CalendarAgenda = () => {
  const { t, i18n } = useTranslation();
  const [openedDate, changeOpenedDate] = useState(clearDayFromDate(new Date())); // TODO: try add undefined if effect dont do it there is one useless render
  const [eventsInModal, showEventsInModal] = useState(undefined);
  const [titleModal, setTitleModal] = useState('');

  const { data: calendarMonth, isFetching } =
    useGetCalendarEventMonthQuery(openedDate);

  const [localizer, changeLocalizer] = useState(dayjsLocalizer(dayjs));

  useEffect(() => {
    dayjs.locale(i18n.language);
    handleResize();
  }, [i18n.language]);

  // Pridanie detekcie veľkosti obrazovky
  const handleResize = () => {
    // Inicializácia alebo aktualizácia na základe veľkosti obrazovky
    changeLocalizer(dayjsLocalizer(dayjs));
  };

  useEffect(() => {
    // Pridanie event listenera pre zmeny veľkosti okna
    window.addEventListener('resize', handleResize);

    // Cleanup event listener pri unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const calendarEvents = useMemo(() => {
    return (
      calendarMonth &&
      calendarMonth.map((singleEvent) => {
        const start = new Date(singleEvent.from);
        const end = singleEvent.to
          ? new Date(singleEvent.to)
          : new Date(singleEvent.from);

        return {
          start,
          end: new Date(end.setHours(1)), // Ensures the end date is at least 1 hour later
          title: singleEvent[`title_${i18n.language}`] || singleEvent.title_sk,
          P: singleEvent.P,
          url: singleEvent.url,
        };
      })
    );
  }, [calendarMonth, i18n.language]);

  const openEventsForDay = (date) => {
    const clickedDate = dayjs(date);

    const filteredByDay =
      calendarEvents &&
      calendarEvents.filter((item) => {
        // item.start item.end
        const startDate = dayjs(item.start);
        const endDate = (item.end && dayjs(item.end)) || dayjs(item.start);

        return (
          isSameDate(clickedDate, startDate) ||
          isSameDate(clickedDate, endDate) ||
          (clickedDate.isAfter(startDate) && clickedDate.isBefore(endDate))
        );
      });

    if (Array.isArray(filteredByDay) && filteredByDay.length > 0) {
      const title =
        t('Všetky udalosti dňa') +
        ' ' +
        clickedDate.format(DATETIME_FORMAT_DATE);

      setTitleModal(title);
      showEventsInModal(filteredByDay);
    }
  };

  return (
    <>
      <ControlsActions
        moveToTop
        actions={[
          {
            to: `${routes.cmsCalendar}`,
            permission: 'calendar.update',
          },
        ]}
      />

      <div className="small-calendar-agenda-component" role="region" aria-label="Calendar">
        {isFetching && <DisabledWithSpinner />}

        <Calendar
          role="grid"
          aria-label={`${new Date(openedDate).toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' })} calendar`}
          components={{
            toolbar: ({ ...all }) => <CustomToolbar {...all} />,
          }}
          localizer={localizer}
          onNavigate={(newDate, view, action) => {
            if (action === 'DATE') {
              openEventsForDay(newDate);
            }
            const clickedDate = clearDayFromDate(newDate);
            if (clickedDate.getMonth() !== openedDate.getMonth()) {
              // toto zavolat len ak je to iny mesiac
              changeOpenedDate(clearDayFromDate(newDate)); // TODO: toto fixnut vola sa po kazdom kliku na kalendaaar !!!!!
            }
          }}
          events={calendarEvents || []}
          formats={{
            dateFormat: 'D',
          }}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 296 }}
          views={['month']}
          eventWrapper={{
            accessors: {
              tooltip: null,
            },
          }}
          selectable={true} // musi byt true aby fungoval click na dni
          longPressThreshold={1}
          onSelectSlot={(clickedEvent) => {
            openEventsForDay(clickedEvent?.start);
          }}
          messages={{
            showMore: () => null,
          }}
          eventPropGetter={(calendarEvent) => {
            const classNameOfEvent =
              calendarEvent.P === 1 ? 'rbc-event-warning' : '';
            return { className: classNameOfEvent };
          }}
        />
      </div>

      <EventsDetailModal
        role="dialog"
        aria-modal="true"
        aria-labelledby="events-modal-title"
        toggle={() => showEventsInModal(undefined)}
        visible={Boolean(eventsInModal)}
        events={eventsInModal}
        title={titleModal}
      />
    </>
  );
};

CalendarAgenda.propTypes = {
  blocksId: PropTypes.number,
};

export default CalendarAgenda;
